import { createSelector } from '@ngrx/store';
import { getAccountsState, IAccountsState } from '../../../states';

export const getCountAccountsResult = createSelector(getAccountsState, (state: IAccountsState) => state.countAccounts?.countData);
